export class ReturnStatus{
    BusinessEIN:string=""
    RecipientName:string=""
    LastFourDigitRecipientTIN:string=""
}